import { CommonModule } from '@angular/common';
import { AfterViewChecked, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

class Message {
  text?: string;
  type: any;
}

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, AfterViewChecked {
  @ViewChild('messageContainer') private messageContainer!: ElementRef;
  public form!: FormGroup;
  public messages: Array<Message> = [];
  showAnswer: boolean = false;
  currentQuestion: number = 1;
  freelancerFAQ: boolean = true;
  clientFAQ: boolean = false;
  showMessageWritter: boolean = false;
  constructor(private formBuilder: FormBuilder){}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      message: [''],
      user_type: ['freelancer'],
    });
    setTimeout(() => {
      this.scrollToBottom();
    }, 5000); 

  }

  ngAfterViewChecked(): void {        
    // this.scrollToBottom();        
  } 

 onClickSendMessage() {
    const message = this.form.get('message')?.value;
    const email = 'contact@cdiwork.com';
    const subject = encodeURIComponent('Support Request');
    const body = encodeURIComponent(message || '');
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
    this.form.reset();
    this.showMessageWritter = false;
  }

 
  onClickEnter(event: any) {
    event.preventDefault();
    this.onClickSendMessage();
  }

  // private scrollToBottom(): void {
  //   this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;         
  // }
  scrollToBottom() {
    try {
      const container = this.messageContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    } catch(err) {
      console.error("Error while scrolling:", err);
    }
  }
  expandAnswer(index: number){
    this.currentQuestion = index;
    this.showAnswer = !this.showAnswer;
  }

  changeUser(user: string){
    if(user === 'freelancer'){
      this.freelancerFAQ = true;
      this.clientFAQ = false;
    }else if(user === 'client'){
      this.freelancerFAQ = false;
      this.clientFAQ = true;
    }
  }
  contactSupport(){
    this.showMessageWritter = true;
  }
}
